/*
 * File: index.js
 * Project: lets-talk-web
 *
 * Created by Morgan Rivera on March 27, 2026 at 2:17 PM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 */

/**
 * Imports
 */

// Utilities
import api from '../api';


/**
 * Services
 */

export const currentUsers = (data) => api.get('/users/currentUsers', data);

export const addUsers = (data) => api.post('/users/addUsers', data);

export const getPendingUsers = (data) => api.get('/users/waitlist', data);

export const approveUsers = (data) => api.post('/users/approveUsers', data);
